export const LOCALES = Object.freeze({
  EN_US: "en-US",
});
